"use strict";

exports.__esModule = true;
exports["default"] = ControlIndex20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlIndex20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 18H3c-.5 0-1-.4-1-1v-2c0-.6.5-1 1-1h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1zM11 18H9c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1h2c.5 0 1 .4 1 1v2c0 .6-.4 1-1 1zM17 18h-2c-.5 0-1-.4-1-1v-2c0-.6.5-1 1-1h2c.5 0 1 .4 1 1v2c0 .6-.5 1-1 1zM5 12H3c-.5 0-1-.5-1-1V9c0-.6.5-1 1-1h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1zM11 12H9c-.6 0-1-.5-1-1V9c0-.6.4-1 1-1h2c.5 0 1 .4 1 1v2c0 .6-.4 1-1 1zM17 12h-2c-.5 0-1-.5-1-1V9c0-.6.5-1 1-1h2c.5 0 1 .4 1 1v2c0 .6-.5 1-1 1zM5 6H3c-.6 0-1-.4-1-1V3c0-.5.5-1 1-1h2c.6 0 1 .5 1 1v2c0 .6-.4 1-1 1zM11 6H9c-.6 0-1-.4-1-1V3c0-.5.4-1 1-1h2c.5 0 1 .5 1 1v2c0 .6-.4 1-1 1zM17 6h-2c-.5 0-1-.4-1-1V3c0-.5.5-1 1-1h2c.5 0 1 .5 1 1v2c0 .6-.5 1-1 1z"
  }));
}